import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { applyStatusColors } from "@/constants/workflow";

const MetaContext = createContext({ version: 0, refresh: () => {} });

export const useMeta = () => useContext(MetaContext);

/** Loads server-side metadata (status colours configured by an admin) once per session. */
export function MetaProvider({ children }) {
  const { user } = useAuth();
  const [version, setVersion] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/meta");
      applyStatusColors(
        Object.fromEntries((data.departments || []).map((d) => [d.key, d.colors || {}]))
      );
      setVersion((v) => v + 1);
    } catch (error) {
      console.debug("meta unavailable", error);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ version, refresh }), [version, refresh]);
  return <MetaContext.Provider value={value}>{children}</MetaContext.Provider>;
}
